import React from 'react';
import { Query, Mutation } from '@apollo/client/react/components';

import CurrentUserWatchlistQuery from 'buyside/graphql/queries/CurrentUserWatchlist.graphql';
import FollowMultipleMutation from 'buyside/graphql/mutations/FollowMultiple.graphql';

import Onboarding from 'buyside/components/presentation/Onboarding/onboarding';
import LoadingSpinner, {
  SIZES
} from 'buyside/components/presentation/LoadingSpinner/loadingSpinner';

const OnboardingContainer = () => {
  return (
    <Query query={CurrentUserWatchlistQuery}>
      {({ loading, data = {} }) => {
        if (loading || !data.currentUser) return <LoadingSpinner size={SIZES.LARGE} />;
        return (
          <Mutation
            mutation={FollowMultipleMutation}
            update={cache => {
              cache.evict({
                id: `User:${data.currentUser.id}`,
                fieldName: 'onboardingFundRecommendations'
              });
              cache.evict({
                id: `User:${data.currentUser.id}`,
                fieldName: 'onboardingFundRecommendationMaxOffset'
              });
            }}
          >
            {followMultiple => (
              <Onboarding
                watchlist={data.currentUser.watchlist || {}}
                isAllocator={data.currentUser.isAllocator}
                followMultiple={followMultiple}
                showUserDetails={data.currentUser.canViewUserDetails}
              />
            )}
          </Mutation>
        );
      }}
    </Query>
  );
};

export default OnboardingContainer;
